module.exports = __webpack_public_path__ + "img/retweet.3e69b8bb.svg";